import {cn} from '@lib/lib/cn';
import {cva, type VariantProps} from 'class-variance-authority';
import * as React from 'react';

const headingVariants = cva('font-[family-name:var(--font-inter),Inter,sans-serif]', {
  variants: {
    size: {
      lg: 'text-header-lg leading-10',
      md: 'text-header-md leading-[1.2]',
      sm: 'text-header-sm leading-[1.2]',
    },
    fontWeight: {
      bold: 'font-bold',
      semibold: 'font-semibold',
      normal: 'font-normal',
    },
  },
  defaultVariants: {
    size: 'md',
    fontWeight: 'bold',
  },
});

type HeadingElement = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement>, VariantProps<typeof headingVariants> {
  as?: HeadingElement;
}

const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(
  ({as: Component = 'h2', className, size, fontWeight, children, ...props}, ref) => {
    return (
      <Component
        data-slot="heading"
        className={cn(headingVariants({size, fontWeight, className}))}
        ref={ref}
        {...props}
      >
        {children}
      </Component>
    );
  },
);

Heading.displayName = 'Heading';

export {Heading, headingVariants};
export type {HeadingProps};
